import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { PRICING_PROFILE_DATE_RANGE_PATH } from '../../../../config/paths';
import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import Loader from '../../../common/Loader';
import NoDataResource from '../../../common/resource/NoDataResource';
import PricingProfileDateRangeToolbar from './PricingProfileDateRangeToolbar';
import {
  clearPricingProfileDateRange,
  getPricingProfileDateRange,
} from '../../../../actions/sales/PricingProfileDateRange';
import PricingProfileDateRangeBasicInformationResource from './resources/PricingProfileDateRangeBasicInformationResource';

export const PricingProfileDateRangeResource = ({
  breadcrumbs,
  dispatchClearPricingProfileDateRange,
  dispatchGetPricingProfileDateRange,
  match: {
    params: { id: pricingProfileDateRangeId },
  },
  loading,
  pricingProfileDateRange,
}) => {
  useLayoutEffect(() => {
    dispatchGetPricingProfileDateRange({ pricingProfileDateRangeId });

    return () => dispatchClearPricingProfileDateRange();
  }, []);

  let content;
  let toolbar;

  if (loading) content = <Loader />;
  else if (pricingProfileDateRange.isEmpty())
    content = <NoDataResource returnPage={PRICING_PROFILE_DATE_RANGE_PATH} />;
  else {
    const pricingProfileDateRangeJson = pricingProfileDateRange.toJS();

    content = (
      <>
        <PricingProfileDateRangeBasicInformationResource
          pricingProfileDateRange={pricingProfileDateRangeJson}
        />
      </>
    );

    toolbar = (
      <PricingProfileDateRangeToolbar
        pricingProfileDateRangeId={pricingProfileDateRangeJson.id}
      />
    );
  }

  return (
    <Content
      breadcrumbs={breadcrumbs}
      toolbar={toolbar}
      title="Rango de Fechas para Perfil de Precio"
      content={content}
    />
  );
};

PricingProfileDateRangeResource.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchClearPricingProfileDateRange: PropTypes.func.isRequired,
  dispatchGetPricingProfileDateRange: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  match: matchPropTypes.isRequired,
  pricingProfileDateRange: PropTypes.instanceOf(Immutable.Map).isRequired,
};

PricingProfileDateRangeResource.defaultProps = {
  loading: false,
};

const mapDispatchToProps = {
  dispatchClearPricingProfileDateRange: clearPricingProfileDateRange,
  dispatchGetPricingProfileDateRange: getPricingProfileDateRange,
};

const mapStateToProps = ({ SalesUnit }) => ({
  breadcrumbs: [
    ...SalesUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Rango de Fechas para Perfiles de Precio',
      href: PRICING_PROFILE_DATE_RANGE_PATH,
    },
    {
      text: 'Ver',
      href: '',
    },
  ],
  pricingProfileDateRange: SalesUnit.PricingProfileDateRange.getIn([
    'current',
    'content',
  ]),
  loading: !SalesUnit.PricingProfileDateRange.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PricingProfileDateRangeResource);
